<template>
  <div class="meal-page">
    <div v-show="!isH5" class="meal-desktop">
      <el-tabs v-model="activeName" data-track-text="充值方式切换" @tab-click="handleClick"
               class="custome-tab">
        <el-tab-pane label="套餐充值" name="taocan">
          <el-main id="recharge-div-one">
            <div class="wallet-summary">
              <img src="../assets/card.png" alt="">
              <div class="wallet-balance">
                <span>钱包余额：</span>
                <span class="wallet-amount">
                  ¥<span>{{ displayTotalMoney }}</span>
                </span>
              </div>
            </div>
          </el-main>
          <el-main id="recharge-div">
            <!-- 充值显示部分标题 -->
            <div class="section-heading">
              <div class="line-div"></div>
              <div class="heading-diamond">
                <img src="../assets/block.png" style="width: 10px">
              </div>
              <span class="title-font center">会员权益</span>
              <div class="heading-diamond">
                <img src="../assets/block.png" style="width: 10px">
              </div>
              <div class="line-div"></div>
            </div>
            <!-- 充值显示部分套餐选项 -->
            <div id="select-div">
              <div class="select-frame" data-track-text="选择套餐一" :class="selectOne" @click="celectFrame('one')">
                <div class="select-font-1" style="width: 100%;text-align: center;">套餐一</div>
                <div class="select-font-2">
                  <span style="font-size: 20px">¥</span>
                  <span>100</span>
                </div>
                <div class="select-font-3">
                  <span style="font-size: 20px">赠10元</span>
                </div>
              </div>
              <div class="select-frame" data-track-text="选择套餐二" :class="selectTwo" @click="celectFrame('two')">
                <div class="select-font-1" style="width: 100%;text-align: center;">套餐二</div>
                <div class="select-font-2">
                  <span style="font-size: 20px">¥</span>
                  <span>200</span>
                </div>
                <div class="select-font-3">
                  <span style="font-size: 20px">赠25元</span>
                </div>
              </div>
              <div class="select-frame" data-track-text="选择套餐三" :class="selectThree" @click="celectFrame('three')">
                <div class="select-font-1" style="width: 100%;text-align: center;">套餐三</div>
                <div class="select-font-2">
                  <span style="font-size: 20px">¥</span>
                  <span>500</span>
                </div>
                <div class="select-font-3">
                  <span style="font-size: 20px">赠60元</span>
                </div>
              </div>
              <div class="select-frame" data-track-text="选择套餐四" :class="selectFour" @click="celectFrame('four')">
                <div class="select-font-1" style="width: 100%;text-align: center;">套餐四</div>
                <div class="select-font-2">
                  <span style="font-size: 20px">¥</span>
                  <span>1000</span>
                </div>
                <div class="select-font-3">
                  <span style="font-size: 20px">赠200元</span>
                </div>
              </div>
            </div>
            <div class="payment-summary">
              <div class="payable-amount">
                <span>应付金额：</span>
                <span>¥<strong>{{ money }}</strong></span>
              </div>
              <button type="button" class="payment-cta" data-track-text="确认支付" @click="payMeal">确认支付</button>
            </div>
          </el-main>
        </el-tab-pane>
        <el-tab-pane label="充值卡充值" name="card">
          <el-main id="recharge-div2">
            <div v-show="!ok" class="custome-content">
              <div class="custome-input">充值卡卡号：
                <el-input v-model="code" clearable></el-input>
              </div>
              <div class="custome-input">充值卡密码：
                <el-input v-model="pass" clearable></el-input>
              </div>
              <div style="padding-top: 10px;margin-bottom: -10px;">
                <span style="color: red;font-size: 12px;font-family: Microsoft YaHei;">{{ message }}</span>
              </div>
              <div style="padding-top: 50px">
                <span class="custome-success" data-track-text="充值卡一键充值" @click="recharge">一键充值</span>
              </div>
              <div class="recharge-help recharge-help--pending">
                <div style="text-align: left;padding: 20px 30px;">
                  <div>
                  <span style="font-size: 16px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  使用说明：
                </span>
                  </div>
                  <div style="padding: 15px 0;">
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                 1. 输入会员充值卡的账号和密码即可给当前登录用户充值。
                </span>
                  </div>
                  <div>
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  2.充值成功后会员卡余额全部转到当下登录用户钱包余额中。
                </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="ok" class="custome-content">
              <div class="recharge-success-heading">
                <div style="float: left;" class="box"></div>
                <div style="    float: left;
                line-height: 40px;
                padding-left: 20px;">
              <span style="font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;">充值成功</span>
                </div>
              </div>
              <div style="margin-top: 70px;font-family: Microsoft YaHei;font-size: 14px;color: #666666">
                <div><span>卡号：{{ code }}</span></div>
                <div style="padding-top: 20px;"><span>充值时间：{{ time }}</span></div>
              </div>
              <div class="recharge-help recharge-help--success">
                <div style="text-align: left;padding: 20px 30px;">
                  <div>
                  <span style="font-size: 16px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  使用说明：
                </span>
                  </div>
                  <div style="padding: 15px 0;">
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                 1. 输入会员充值卡的账号和密码即可给当前登录用户充值。
                </span>
                  </div>
                  <div>
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  2.充值成功后会员卡余额全部转到当下登录用户钱包余额中。
                </span>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-tab-pane>
      </el-tabs>
      <el-footer id="record-div">
        <div class="section-heading record-heading">
          <div class="line-div"></div>
          <div class="heading-diamond">
            <img src="../assets/block.png" style="width: 10px">
          </div>
          <span class="title-font center">充值记录</span>
          <div class="heading-diamond">
            <img src="../assets/block.png" style="width: 10px">
          </div>
          <div class="line-div"></div>
        </div>
        <div class="records-table">
          <el-table
            :height="400"
            :header-cell-style="{ 'background': '#eeeeee','font-weight': '400','color': '#666666','font-family':'Source Han Sans CN'}"
            :data="tableData"
            style="width: 100%;">
            <el-table-column
              align="center"
              min-width="82"
              prop="createTime"
              label="时间">
            </el-table-column>
            <el-table-column
              align="center"
              min-width="88"
              prop="amount"
              label="充值金额">
            </el-table-column>
            <el-table-column
              align="center"
              min-width="48"
              prop="memo"
              label="赠送">
            </el-table-column>
            <el-table-column
              align="center"
              min-width="48"
              prop="zonge"
              label="总额">
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: right;" v-if="mealTotal!==0&&mealTotal>10">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="mealTotal"
            @prev-click="prevClick"
            @next-click="nextClick"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </el-footer>
    </div>
    <div class="user-main" v-show="isH5">
      <div class="user-main-head legacy-root-header">
        <img data-track-text="返回首页" @click="clickHanler('/index')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
        <div>用户充值</div>
      </div>
      <div class="user-main-select">
        <div data-track-text="切换套餐充值" @click="()=>activeName='taocan'" :class="activeName==='taocan'?'ischeck':''">套餐充值</div>
        <div data-track-text="切换充值卡充值" @click="()=>activeName='card'" :class="activeName==='card'?'ischeck':''">充值卡充值</div>
      </div>
      <div v-show="activeName==='taocan'">
        <div style="display: flex;align-items: center;margin-top:26px;width: 768px;height: 80px;background: #FFFFFF;">
          <img style="margin-left: 35px;margin-right: 27px" src="../assets/card.png" alt="">
          <div style="font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">
            钱包余额：<span style="color:rgba(225, 63, 63, 1);">¥<span
            style="color:rgba(225, 63, 63, 1);font-size: 30px">{{ displayTotalMoney }}</span></span>
          </div>
        </div>
        <div style="display: flex; flex-flow: column;margin-top: 27px;width: 768px;height: 1120px;background: #FFFFFF;">
          <div style="padding-top: 40px;display: flex;align-items: center;justify-content: center;">
            <div style="width: 110px;height: 1px;background: #DDDDDD;margin-right: 6px"></div>
            <div
              style="transform: rotate(7deg); -ms-transform: rotate(50deg); -moz-transform: rotate(50deg); -webkit-transform: rotate(50deg); -o-transform: rotate(50deg);width: 18px;height: 18px;background: #DDDDDD;"></div>
            <div style="margin: 0 19px;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">
              会员权益
            </div>
            <div
              style="transform: rotate(7deg); -ms-transform: rotate(50deg); -moz-transform: rotate(50deg); -webkit-transform: rotate(50deg); -o-transform: rotate(50deg);width: 18px;height: 18px;background: #DDDDDD;"></div>
            <div style="width: 110px;height: 1px;background: #DDDDDD;margin-left: 6px"></div>
          </div>
          <div style="margin-top: 58px;display: flex;align-items: center;justify-content: center;">
            <div class="select-frame-h5" data-track-text="选择套餐一" style="margin-right: 46px;margin-bottom:36px " :class="selectOne"
                 @click="celectFrame('one')">
              <div
                style="margin-top:54px;text-align: center;font-size: 36px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;">
                套餐一
              </div>
              <div class="select-font-2">
                <span style="font-size: 24px">¥</span>
                <span style="font-size: 64px">100</span>
              </div>
              <div class="select-font-3">
                <span style="font-size: 30px">赠10元</span>
              </div>
            </div>
            <div class="select-frame-h5" data-track-text="选择套餐二" style="margin-bottom:36px " :class="selectTwo" @click="celectFrame('two')">
              <div
                style="margin-top:54px;text-align: center;font-size: 36px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;">
                套餐二
              </div>
              <div class="select-font-2">
                <span style="font-size: 24px">¥</span>
                <span style="font-size: 64px">200</span>
              </div>
              <div class="select-font-3">
                <span style="font-size: 30px">赠25元</span>
              </div>
            </div>
          </div>
          <div style="display: flex;align-items: center;justify-content: center;">
            <div class="select-frame-h5" data-track-text="选择套餐三" style="margin-right: 46px;margin-bottom:36px " :class="selectThree"
                 @click="celectFrame('three')">
              <div
                style="margin-top:54px;text-align: center;font-size: 36px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;">
                套餐三
              </div>
              <div class="select-font-2">
                <span style="font-size: 24px">¥</span>
                <span style="font-size: 64px">500</span>
              </div>
              <div class="select-font-3">
                <span style="font-size: 30px">赠60元</span>
              </div>
            </div>
            <div class="select-frame-h5" data-track-text="选择套餐四" style="margin-bottom:36px " :class="selectFour" @click="celectFrame('four')">
              <div
                style="margin-top:54px;text-align: center;font-size: 36px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;">
                套餐四
              </div>
              <div class="select-font-2">
                <span style="font-size: 24px">¥</span>
                <span style="font-size: 64px">1000</span>
              </div>
              <div class="select-font-3">
                <span style="font-size: 30px">赠200元</span>
              </div>
            </div>

          </div>
          <div style="margin-right: 30px;display: flex;    flex-flow: column;align-items: flex-end;">
            <div style="font-size: 30px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">应付金额：
              <span style="color: #e13f3f;font-size: 30px">¥ <span style="font-size: 30px">{{
                  money
                }}</span></span></div>
            <div data-track-text="确认支付" @click="payMeal"
                 style="margin-top: 27px;display: flex;align-items: center;justify-content: center;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;width: 260px;height: 80px;background: #063F95;">
              确认支付
            </div>
          </div>
        </div>
        <div style="display: flex;flex-flow: column;align-items: center;margin-top:25px;background: #FFFFFF;">
          <div style="padding-top: 40px;display: flex;align-items: center;justify-content: center;">
            <div style="width: 110px;height: 1px;background: #DDDDDD;margin-right: 6px"></div>
            <div
              style="transform: rotate(7deg); -ms-transform: rotate(50deg); -moz-transform: rotate(50deg); -webkit-transform: rotate(50deg); -o-transform: rotate(50deg);width: 18px;height: 18px;background: #DDDDDD;"></div>
            <div style="margin: 0 19px;font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">
              会员权益
            </div>
            <div
              style="transform: rotate(7deg); -ms-transform: rotate(50deg); -moz-transform: rotate(50deg); -webkit-transform: rotate(50deg); -o-transform: rotate(50deg);width: 18px;height: 18px;background: #DDDDDD;"></div>
            <div style="width: 110px;height: 1px;background: #DDDDDD;margin-left: 6px"></div>
          </div>
          <div
            style="display: flex;align-items: center;justify-content: space-evenly;width: 709px;margin-top:18px;height: 68px;background: #F5F5F5;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
            <div>时间</div>
            <div>充值金额</div>
            <div>赠送</div>
            <div>总额</div>
          </div>
          <div v-for="item in tableData">
            <div
              style="display: flex;align-items: center;justify-content: space-evenly;width: 709px;margin-top:18px;height: 68px;font-size: 24px;font-family: Adobe Heiti Std;font-weight: normal;color: #666666;">
              <div>{{ item.createTime }}</div>
              <div>{{ item.amount }}</div>
              <div>{{ item.memo }}</div>
              <div>{{ item.zonge }}</div>
            </div>
          </div>
          <div style="height: 60px;display: flex;justify-content: center;align-items: center;width: 100%;"
               v-if="mealTotal!==0&&mealTotal>10">
            <el-pagination
              class="el-page"
              background
              layout="prev, pager, next"
              :page-size="10"
              :total="mealTotal"
              @prev-click="prevClick"
              @next-click="nextClick"
              @current-change="currentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-show="activeName!=='taocan'">
        <div class="user-main-select-taocan">
          <div v-show="!ok" class="custome-content-h5">
            <div class="custome-input-h5">充值卡卡号：
              <el-input v-model="code" clearable></el-input>
            </div>
            <div class="custome-input-h5">充值卡密码：
              <el-input v-model="pass" clearable></el-input>
            </div>
            <div style="padding-top: 10px;margin-bottom: -10px;">
              <span style="color: red;font-size: 24px;font-family: Microsoft YaHei;">{{ message }}</span>
            </div>
            <div style="padding-top: 50px">
              <div class="custome-success-h5" data-track-text="充值卡一键充值" @click="recharge">一键充值</div>
            </div>
            <div style="margin-top:457px;width: 710px;height: 153px;background: #F5F5F5;">
              <div style="text-align: left;padding: 15px 30px;">
                <div>
                  <span style="font-size: 24px;
font-family: Adobe Heiti Std;
font-weight: normal;
color: #333333;">
                  使用说明：
                </span>
                </div>
                <div style="padding: 15px 0;">
                  <span style="font-size: 24px;
font-family: Adobe Heiti Std;
font-weight: normal;
color: #333333;">
                 1. 输入会员充值卡的账号和密码即可给当前登录用户充值。
                </span>
                </div>
                <div>
                  <span style="font-size: 24px;
font-family: Adobe Heiti Std;
font-weight: normal;
color: #333333;">
                  2.充值成功后会员卡余额全部转到当下登录用户钱包余额中。
                </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="ok" class="custome-content">
            <div style="transform: translate(40%, -20px);">
              <div style="float: left;" class="box"></div>
              <div style="    float: left;
                line-height: 40px;
                padding-left: 20px;">
              <span style="font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;">充值成功</span>
              </div>
            </div>
            <div style="margin-top: 70px;font-family: Microsoft YaHei;font-size: 14px;color: #666666">
              <div><span>卡号：{{ code }}</span></div>
              <div style="padding-top: 20px;"><span>充值时间：{{ time }}</span></div>
            </div>
            <div style="margin-top:185px;width: 818px;
                  height: 132px;
                  background: #F5F5F5;">
              <div style="text-align: left;padding: 20px 30px;">
                <div>
                  <span style="font-size: 16px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  使用说明：
                </span>
                </div>
                <div style="padding: 15px 0;">
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                 1. 输入会员充值卡的账号和密码即可给当前登录用户充值。
                </span>
                </div>
                <div>
                  <span style="font-size: 14px; font-family: Microsoft YaHei; font-weight: bold; color: #999999;">
                  2.充值成功后会员卡余额全部转到当下登录用户钱包余额中。
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {isSmallScreen} from '@/utils/responsive'

export default {
  name: "Meal",
  data() {
    return {
      message: "",
      time: undefined,
      ok: false,
      code: "",
      pass: "",
      activeName: 'taocan',
      selectOne: 'select-frame-active',
      selectTwo: '',
      selectThree: '',
      selectFour: '',
      tableData: [],
      mealTotal: 0,
      money: 100,
      totalMmoney: null,
      meal: 'MealOne',
      isH5: false,
    }
  },
  computed: {
    displayTotalMoney() {
      const balance = this.totalMmoney
      if (typeof balance === 'boolean' || balance === null || balance === undefined || balance === '') {
        return '--'
      }
      const numericBalance = Number(balance)
      return Number.isFinite(numericBalance) ? numericBalance.toFixed(2) : '--'
    }
  },
  beforeMount() {
    this.updateViewportMode()
  },
  mounted() {
    this.getRechargeOrder(0, 10);
    this.getTotalMoney();
    window.addEventListener('resize', this.updateViewportMode)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportMode)
  },
  methods: {
    clickHanler(url) {
      document.location.href = "https://wesitrans.com/index"
    },
    isMobile() {
      return isSmallScreen()
    },
    updateViewportMode() {
      this.isH5 = this.isMobile()
    },
    getNowFormatDate(date) {
      var seperator1 = "-";
      var seperator2 = ":";
      var year = date.getFullYear();
      var month = this.numberFormat(date.getMonth() + 1);
      var strDate = this.numberFormat(date.getDate());
      var hours = this.numberFormat(date.getHours());
      var minutes = this.numberFormat(date.getMinutes());
      var seconds = this.numberFormat(date.getSeconds());
      var currentdate = year + seperator1 + month + seperator1 + strDate
        + " " + hours + seperator2 + minutes
        + seperator2 + seconds;
      return currentdate;
    },
    numberFormat(number) {
      return number > -1 && number < 10 ? "0" + number : number;
    },
    recharge() {
      const that = this;
      if (this.code === "" || this.code === undefined || this.code === null) {
        this.$track('recharge_card_submit_result', {result: 'validation_failed', reason: 'missing_card'})
        this.message = "充值卡卡号不能为空"
        return
      }
      if (this.pass === "" || this.pass === undefined || this.pass === null) {
        this.$track('recharge_card_submit_result', {result: 'validation_failed', reason: 'missing_password'})
        this.message = "充值卡密码不能为空"
        return
      }
      this.$track('recharge_card_submit', {action: 'submit'})
      this.$http.post('/api/recharge/card', {
        code: this.code,
        pass: this.pass
      }).then(res => {
        let data = res.data;
        if (data === "" || data === undefined) {
          this.$track('recharge_card_submit_result', {result: 'success'})
          that.ok = true
          that.time = this.getNowFormatDate(new Date())
          that.getRechargeOrder(0, 10)
          this.getTotalMoney();
          return
        }
        this.$track('recharge_card_submit_result', {result: 'failure'})
        this.message = data
      }).catch(err => {
        this.$track('recharge_card_submit_result', {result: 'failure', reason: 'request_failed'})
        this.message = "充值失败请重试"
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getTotalMoney() {
      const that = this;
      this.$http.post('/api/recharge/getTotalMoney').then(function (response) {
        that.totalMmoney = response.data
      }).catch(function (error) {
        that.totalMmoney = null
      });
    },
    nextClick(val) {
      this.$track('recharge_history_page', {action: 'next', pageNumber: val, pageSize: 10})
      this.getRechargeOrder(val, 10)
    },
    prevClick(val) {
      this.$track('recharge_history_page', {action: 'previous', pageNumber: val, pageSize: 10})
      this.getRechargeOrder(val, 10)
    },
    currentChange(val) {
      this.$track('recharge_history_page', {action: 'select', pageNumber: val, pageSize: 10})
      this.getRechargeOrder(val, 10)
    },
    celectFrame(val) {
      this.selectOne = '';
      this.selectTwo = '';
      this.selectThree = '';
      this.selectFour = '';
      switch (val) {
        case 'one':
          this.selectOne = 'select-frame-active';
          this.money = 100;
          this.meal = "MealOne"
          break;
        case 'two':
          this.selectTwo = 'select-frame-active';
          this.money = 200;
          this.meal = "MealTwo"
          break;
        case 'three':
          this.selectThree = 'select-frame-active';
          this.money = 500;
          this.meal = "MealThree"
          break;
        case 'four':
          this.selectFour = 'select-frame-active';
          this.money = 1000;
          this.meal = "MealFour"
          break;

      }
      this.$track('recharge_plan_select', {plan: this.meal, amount: this.money})
    },
    getRechargeOrder(currentPage, pageSize) {
      const that = this;
      this.$http.post('/api/getRechargeOrder', {
        "currentPage": currentPage,
        "pageSize": pageSize
      }).then(function (response) {
        if (response.data) {
          that.mealTotal = response.data.totalCount;
          that.tableData = [];
          response.data.orders.forEach((item, index) => {
            const data = {}
            data.createTime = item.createTime
            data.memo = "+" + item.memo
            data.zonge = item.amount + parseFloat(item.memo)
            let payChannel = item.payChannel
            if (payChannel !== null && payChannel !== undefined && payChannel !== "" && payChannel === "601") {
              data.amount = "充值卡充值 " + item.amount + "元";
            } else if (payChannel === '6') {
              data.amount = "退款金额 " + item.amount + "元";
            } else if (payChannel === '7') {
              data.amount = "参与奖 " + item.amount + "元";
            } else {
              switch (item.amount) {
                case 100 :
                  data.amount = "充值套餐一 100元";
                  break;
                case 200:
                  data.amount = "充值套餐二 200元";
                  break;
                case 500:
                  data.amount = "充值套餐三 500元";
                  break;
                case 1000:
                  data.amount = "充值套餐四 1000元";
                  break;
                default:
                  data.amount = "注册赠送 18元";
                  data.memo = "+0"
                  break;
              }
            }
            that.tableData.push(data)
          });
        }
      }).catch(function (error) {
      });
    },
    payMeal() {
      const that = this;
      let payUrl = process.env.VUE_APP_PAY;
      this.$track('recharge_pay_submit', {plan: this.meal, amount: this.money, channel: this.isH5 ? 'h5' : 'pc'})
      this.$http.post('/api/recharge/getRequest', {
        mealType: this.meal
      }).then(function (response) {
        if (response.data) {
          that.$track('recharge_pay_request_result', {result: 'success', plan: that.meal, amount: that.money})
          window.open(payUrl + response.data, "_self")
          return
        }
        that.$track('recharge_pay_request_result', {result: 'failure', reason: 'empty_request'})
        that.$message({
          type: 'info',
          message: '请稍后再试!'
        });
      }).catch(function (error) {
        that.$track('recharge_pay_request_result', {result: 'failure', reason: 'request_failed'})
        that.$message({
          type: 'info',
          message: '请稍后再试!'
        });
      });
    }
  }
}
</script>

<style scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0c7dba;
  color: #FFF;
}

/deep/ .el-page.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgb(6, 63, 149);
  color: #FFF;
}

/deep/ .el-page.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 50px;
  border-radius: 2px;
}

/deep/ .el-page .el-pager li {
  padding: 0 4px;
  background: #FFF;
  font-size: 22px;
  min-width: 35.5px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  text-align: center;
}

/deep/ .el-page.el-pagination button, .el-pagination span:not([class*=suffix]) {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 40px;
  line-height: 28px;
  vertical-align: top;
  box-sizing: border-box;
}

/deep/ .el-page.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 60px;
  border-radius: 2px;
}

/deep/ .el-page.el-pagination.is-background .btn-prev, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 60px;
  border-radius: 2px;
}

.select-frame-h5 {
  width: 319px;
  height: 366px;
  background: #FFFFFF;
  border: 1px solid #E8E9ED;
  box-shadow: 0px 0px 3px 0px rgba(3, 27, 63, 0.1);
  border-radius: 10px;
}

.ischeck {
  border-bottom: 3px solid #063F95;
}

.user-main-select div:nth-child(1) {
  margin-left: 34px;
  margin-right: 63px;
  height: 80px;
  display: flex;
  align-items: center;
}

.user-main-select div:nth-child(2) {
  height: 80px;
  display: flex;
  align-items: center;
}

.user-main-select {
  width: 768px;
  height: 80px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-select-taocan {
  width: 768px;
  height: 1005px;
  background: #FFFFFF;
  margin-top: 26px;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}


.box {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  border: 5px solid #0EB4B7;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0EB4B7;
}

.box::before {
  content: "";
  display: block;
  width: 22px;
  height: 10px;
  border: 4px solid #ffffff;
  border-right: none;
  border-top: none;
  transform: rotate(
    -45deg
  ) translate(3px, -2px);
}

.custome-success {
  background: #063f95;
  border-radius: 2px;
  font-size: 14px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  cursor: pointer;
  padding: 10px 45px;
}

.custome-success-h5 {
  width: 260px;
  height: 80px;
  background: #063F95;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custome-success:hover {
  background: #0c7dba;
  border-radius: 2px;
  font-size: 14px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #FFFFFF;
  cursor: pointer;
  padding: 10px 45px;
}

.custome-content {
  padding-top: 60px;
}

.custome-content-h5 {
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-top: 30px;
}

.custome-input-h5 {
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #666666;
}

>>> .custome-input-h5 .el-input {
  width: 553px;
  padding: 11px;
}

>>> .custome-input-h5 .el-input .el-input__inner {
  width: 553px;
  height: 65px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

>>> .custome-input .el-input {
  width: 470px;
  padding: 11px;
}

>>> .custome-input .el-input .el-input__inner {
  width: 470px;
  height: 40px;
  border: 1px solid #DDDDDD;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
}

.custome-tab {
  height: 640px;
}

.meal-page,
.meal-desktop {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.meal-desktop {
  overflow-x: hidden;
}

.wallet-summary {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-left: 25px;
  color: #333333;
  font-family: Noto Sans S Chinese, Microsoft YaHei, sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.wallet-summary img {
  flex: 0 0 auto;
}

.wallet-balance {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.wallet-amount {
  color: #333333;
  font-size: 16px;
}

.wallet-amount > span {
  font-size: 30px;
}

.section-heading {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.section-heading .line-div {
  flex: 0 1 98px;
}

.heading-diamond {
  display: flex;
  align-items: center;
  margin: 0 7px;
}

.section-heading .title-font {
  flex: 0 0 auto;
  margin: 0 5px;
}

.payment-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: 45px 35px 0 45px;
  color: #333333;
  font-family: Noto Sans S Chinese, Microsoft YaHei, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}

.payable-amount {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
}

.payable-amount > span:last-child {
  color: #e13f3f;
  font-size: 16px;
}

.payable-amount strong {
  font-size: 30px;
  font-weight: 400;
}

.payment-cta {
  width: 166px;
  height: 48px;
  border: 0;
  border-radius: 3px;
  background: #063f95;
  color: #ffffff;
  cursor: pointer;
  flex: 0 0 auto;
  font-family: Noto Sans S Chinese, Microsoft YaHei, sans-serif;
  font-size: 18px;
}

.payment-cta:hover,
.payment-cta:focus-visible {
  background: #0c7dba;
}

.recharge-help {
  width: min(818px, 100%);
  min-height: 132px;
  margin-left: auto;
  margin-right: auto;
  background: #F5F5F5;
  box-sizing: border-box;
}

.recharge-help--pending {
  margin-top: 120px;
}

.recharge-help--success {
  margin-top: 185px;
}

.recharge-success-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.records-table {
  width: 100%;
  min-width: 0;
}

>>> .custome-tab .el-tabs__header {
  height: 60px;
  margin: 0;
}

>>> .custome-tab .el-tabs__header .el-tabs__nav-wrap {
  height: 60px;
}

>>> .custome-tab .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll {
  height: 60px;
  background: white;
  padding-left: 45px;
}

>>> .custome-tab .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  height: 60px;
  line-height: 4;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

>>> .custome-tab .el-tabs__active-bar {
  background-color: #0c7dba;
}

>>> .custome-tab .el-tabs__item.is-active {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0c7dba;
}

>>> .custome-tab .el-tabs__item {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

>>> .custome-tab .el-tabs__item:hover {
  color: #0c7dba;
}

#recharge-div-one {
  background: #FFFFFF;
  overflow: hidden;
  margin-bottom: 20px;
}

#recharge-div {
  background: #FFFFFF;
  overflow: hidden;
  height: 480px;
}

#recharge-div2 {
  background: #FFFFFF;
  overflow: hidden;
  height: 580px;
}

#record-div {
  margin-top: 20px;
  height: 700px !important;
  background: #FFFFFF;
}

.title-font {
  width: 96px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #949494;
  margin-top: 27px;
}

.line-div {
  width: 98px;
  height: 1px;
  background: #DDDDDD;
}

#select-div {
  height: 211px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 150px));
  justify-content: space-between;
  gap: 20px;
  padding: 0 22px;
  box-sizing: border-box;
}

.select-frame {
  width: 100%;
  height: 180px;
  box-sizing: border-box;
  background-color: white;
  border: 2px solid #DFB465;
  border-radius: 10px;
  cursor: pointer;
}

.select-frame-active {
  background: #fcf5eb !important;
  border: 2px solid #DFB465;
}

.select-font-1 {
  height: 25px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #27314B;
  margin-top: 15px;
}

.select-font-2 {
  font-size: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #DFB465;
  text-align: center;
  padding: 20px;
}

.select-font-3 {
  height: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #8F94A7;
  text-align: center;
}

@media (max-width: 768px) {
  .meal-page {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .meal-desktop {
    display: block !important;
    width: 100%;
    overflow-x: hidden;
  }

  .user-main {
    display: none !important;
  }

  .custome-tab {
    height: auto;
  }

  >>> .custome-tab .el-tabs__content {
    overflow: visible;
  }

  >>> .custome-tab .el-tabs__header,
  >>> .custome-tab .el-tabs__header .el-tabs__nav-wrap,
  >>> .custome-tab .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll {
    height: 52px;
  }

  >>> .custome-tab .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
    padding-left: 0;
  }

  >>> .custome-tab .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
    height: 52px;
    line-height: 3.45;
  }

  #recharge-div-one,
  #recharge-div,
  #recharge-div2,
  #record-div {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  #recharge-div-one {
    margin-bottom: 10px;
    padding: 14px 16px;
  }

  .wallet-summary {
    gap: 14px;
    margin-left: 0;
    font-size: 14px;
  }

  .wallet-summary img {
    width: 34px;
    height: auto;
  }

  .wallet-balance {
    flex-wrap: wrap;
  }

  .wallet-amount,
  .wallet-amount > span {
    font-size: 22px;
  }

  #recharge-div {
    height: auto;
    padding: 0 12px 18px;
  }

  .section-heading {
    height: 62px;
  }

  .section-heading .line-div {
    flex: 1 1 42px;
    max-width: 52px;
  }

  .heading-diamond {
    margin: 0 5px;
  }

  .heading-diamond img {
    width: 7px !important;
  }

  .section-heading .title-font {
    width: auto;
    height: auto;
    margin: 0 6px;
    font-size: 17px;
    line-height: 24px;
  }

  #select-div {
    height: auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    padding: 0;
  }

  .select-frame {
    min-width: 0;
    height: 124px;
    border-width: 1px;
    border-radius: 8px;
  }

  .select-frame-active {
    border-width: 1px;
  }

  .select-font-1 {
    height: auto;
    margin-top: 12px;
    font-size: 16px;
    line-height: 22px;
  }

  .select-font-2 {
    padding: 9px 3px 7px;
    font-size: 29px;
    line-height: 34px;
  }

  .select-font-2 span:first-child,
  .select-font-3 span {
    font-size: 14px !important;
  }

  .select-font-3 {
    height: auto;
    font-size: 14px;
    line-height: 20px;
  }

  .payment-summary {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin: 20px 0 0;
  }

  .payable-amount {
    justify-content: center;
    font-size: 14px;
  }

  .payable-amount strong {
    font-size: 24px;
  }

  .payment-cta {
    width: 100%;
    height: 42px;
    font-size: 16px;
  }

  #recharge-div2 {
    height: auto;
    min-height: 500px;
    padding: 0 16px 20px;
  }

  .custome-content {
    width: 100%;
    min-width: 0;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .custome-input {
    width: 100%;
    text-align: left;
  }

  >>> .custome-input .el-input,
  >>> .custome-input .el-input .el-input__inner {
    width: 100%;
    box-sizing: border-box;
  }

  >>> .custome-input .el-input {
    padding: 8px 0 12px;
  }

  .recharge-help {
    width: 100%;
    min-height: 0;
    height: auto;
  }

  .recharge-help--pending,
  .recharge-help--success {
    margin-top: 60px;
  }

  .recharge-help > div {
    padding: 16px !important;
  }

  .recharge-help span {
    font-size: 13px !important;
    line-height: 20px;
  }

  #record-div {
    height: auto !important;
    min-height: 520px;
    margin-top: 10px;
    padding: 0 12px 76px;
  }

  .record-heading {
    height: 62px;
  }

  >>> .records-table .el-table,
  >>> .records-table .el-table__header-wrapper,
  >>> .records-table .el-table__body-wrapper {
    width: 100% !important;
    max-width: 100%;
  }

  >>> .records-table .el-table th,
  >>> .records-table .el-table td {
    padding: 8px 0;
  }

  >>> .records-table .el-table .cell {
    padding: 0 2px;
    font-size: 11px;
    line-height: 16px;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  >>> #record-div .el-pagination {
    display: flex;
    justify-content: center;
    padding: 12px 0 0;
    white-space: normal;
  }

  >>> #record-div .el-pagination.is-background .btn-next,
  >>> #record-div .el-pagination.is-background .btn-prev,
  >>> #record-div .el-pagination.is-background .el-pager li {
    min-width: 24px;
    margin: 0 2px;
  }
}
</style>
